import AppDispatcher from '../dispatcher/AppDispatcher';
import FavouritesConstants from '../constants/FavouritesConstants';

//TODO: move to utils directory
const raise = (actionType, data) => {
  AppDispatcher.handleViewAction({
    actionType,
    data,
  });
};

export const getFavouriteAccounts = () => {
  raise(FavouritesConstants.REQUEST_FAVOURITE_ACCOUNTS);
};

export const handleSuccessResponseGetFavourites = (response) => {
  raise(FavouritesConstants.REQUEST_FAVOURITE_ACCOUNTS_SUCCESS, response);
};

export const handleErrorResponseGetFavourites = (error, status) => {
  raise(FavouritesConstants.REQUEST_FAVOURITE_ACCOUNTS_FAILURE, {
    error,
    status,
  });
};

export const handleSuccessResponseAddFavourite = (account) => {
  raise(FavouritesConstants.ADD_FAVOURITE_ACCOUNTS_SUCCESS, account);
};

export const handleErrorResponseAddFavourite = (error, status) => {
  raise(FavouritesConstants.ADD_FAVOURITE_ACCOUNTS_FAILURE, { error, status });
};

export const handleSuccessResponseRemoveFavourite = (id) => {
  raise(FavouritesConstants.REMOVE_FAVOURITE_ACCOUNTS_SUCCESS, id);
};

export const handleErrorResponseRemoveFavourite = (error, status) => {
  raise(FavouritesConstants.REMOVE_FAVOURITE_ACCOUNTS_FAILURE, {
    error,
    status,
  });
};

export const handleErrorExceededMaxFavourites = (error, status) => {
  raise(FavouritesConstants.SET_FAVOURITE_ACCOUNTS_EXCEEDED_MAX, {
    error,
    status,
  });
};

export const clearSelectedAccountId = () => {
  raise(FavouritesConstants.CLEAR_SELECTED_ACCOUNT_ID);
};
